import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthComplete = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Passwordless sign-in has been removed; send users back to the auth page
    navigate('/auth');
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="text-red-600 text-5xl mb-4">
          <svg className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Passwordless Sign‑in Disabled</h2>
        <p className="text-gray-600 mb-4">Please sign in using your email and password.</p>
        <button
          onClick={() => navigate('/auth')}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
        >
          Back to Auth
        </button>
      </div>
    </div>
  );
};

export default AuthComplete;